import React from 'react';
import PropTypes from 'prop-types';

export const Rates = ({ width, height, ...props }) => (
  <svg
    data-icon='rates'
    width={ width }
    height={ height }
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    { ...props }
  >
    <path
      d='M9 21L2 14H16L9 21Z'
      fill='currentColor'
    />
    <path
      d='M15 3L22 10L8 10L15 3Z'
      fill='currentColor'
    />
  </svg>
);

Rates.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Rates.defaultProps = {
  width: 24,
  height: 24,
};
